module.exports = __webpack_public_path__ + "static/media/ageelementbrighteningconcentrate.52f213d3.png";